import { buildCalculatorLd } from "@/lib/page-schemas";
import { CLUSTER_META, type WeekPageData } from "./week-data";

export function pregnancyPageScripts(data: WeekPageData) {
  return buildCalculatorLd({
    url: data.meta.canonical,
    name: `${CLUSTER_META[data.cluster].label} — Week ${data.week}`,
    description: data.meta.description,
    applicationCategory: "HealthApplication",
    featureList: ["Estimated due date", "Pregnancy timeline", "Week-specific guidance", "Printable calculation"],
    howTo: {
      name: `How to use the ${CLUSTER_META[data.cluster].label}`,
      totalTime: "PT2M",
      steps: data.cluster === "ivf"
        ? [
            { name: "Enter retrieval date", text: "Select the date of egg retrieval." },
            { name: "Choose transfer timing", text: "Select whether the embryo transfer was on day 3 or day 5." },
            { name: "Review the estimate", text: "Review the estimated due date and discuss clinical dating with your care team." },
          ]
        : [
            { name: "Enter LMP date", text: "Select the first day of the last menstrual period." },
            { name: "Review the timeline", text: "The calculator adds 280 days and shows the current gestational age." },
            { name: "Confirm clinically", text: "Use the estimate for planning and confirm pregnancy dating with your clinician." },
          ],
    },
    faqs: data.faqs,
    trail: [
      { name: "Home", item: "https://drhint.com/" },
      { name: CLUSTER_META[data.cluster].label, item: `https://drhint.com${CLUSTER_META[data.cluster].routePattern(1)}` },
      { name: `Week ${data.week}`, item: data.meta.canonical },
    ],
  });
}